"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Dom = require("UIComponents/utils/Dom");

var _iterables = require("rich-text-lib/utils/iterables");

var _Toolbar = _interopRequireDefault(require("rich-text-lib/components/toolbar/Toolbar"));

var _toolbar = require("../constants/toolbar");

var TinymceToolbar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinymceToolbar, _Component);

  function TinymceToolbar() {
    var _this;

    (0, _classCallCheck2.default)(this, TinymceToolbar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinymceToolbar).call(this));

    _this.handleEditorMouseDown = function () {
      _this.mouseDownInEditor = true;
    };

    _this.handleEditorMouseUp = function (event) {
      if (!_this.mouseDownInEditor) {
        event.preventDefault();
      }

      _this.mouseDownInEditor = false;
    };

    _this.convertToButton = function (name) {
      var button = _this.props.editor.buttons[name];

      if (typeof button === 'undefined') {
        throw new Error("[tinymce-themes] " + name + " is not registered a button with TinyMCE");
      }

      var control = typeof button === 'function' ? button() : button;
      return (0, _extends2.default)({}, control, {
        name: name
      });
    };

    _this.convertToMenuItem = function (name) {
      var menuItem = _this.props.editor.menuItems[name];

      if (typeof menuItem === 'undefined') {
        throw new Error("[tinymce-themes] " + name + " is not registered a menuItem with TinyMCE");
      }

      menuItem = typeof menuItem === 'function' ? menuItem() : menuItem;
      return {
        name: name,
        text: menuItem.text,
        onClick: menuItem.onclick,
        render: menuItem.render,
        child: menuItem.child,
        icon: _toolbar.Icons[name]
      };
    };

    _this.handleMoreMenuOpenComplete = _this.handleMoreMenuOpenComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleWindowMouseDown = _this.handleWindowMouseDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TinymceToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('mousedown', this.handleWindowMouseDown);
      this.props.editor.on('mousedown', this.handleEditorMouseDown);
      this.props.editor.on('mouseup', this.handleEditorMouseUp, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.handleWindowMouseDown);
      this.props.editor.off('mousedown', this.handleEditorMouseDown);
      this.props.editor.off('mouseup', this.handleEditorMouseUp);
    }
  }, {
    key: "handleWindowMouseDown",
    value: function handleWindowMouseDown(e) {
      var editor = this.props.editor;

      if (editor.editorManager.focusedEditor && (0, _Dom.closest)(e.target, "[class*=mce-]") === null) {
        editor.editorManager.focusedEditor.fire('focusout');
      }
    }
  }, {
    key: "handleMoreMenuOpenComplete",
    value: function handleMoreMenuOpenComplete() {
      var _this2 = this;

      setTimeout(function () {
        _this2.props.editor.nodeChanged({
          selectionChange: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_Toolbar.default, (0, _extends2.default)({
        convertToButton: this.convertToButton,
        convertToMenuItem: this.convertToMenuItem,
        dropdownClassName: "mce-hubspot-dropdown",
        tabIndex: "-1",
        onMoreMenuOpenComplete: this.handleMoreMenuOpenComplete
      }, (0, _iterables.omit)(Object.keys(TinymceToolbar.propTypes), this.props)));
    }
  }]);
  return TinymceToolbar;
}(_react.Component);

exports.default = TinymceToolbar;
TinymceToolbar.propTypes = {
  editor: _react.PropTypes.object.isRequired
};
module.exports = exports.default;